import { useEffect, useState } from "react";

import axios from "axios";
import remarkGfm from "remark-gfm";

import ReactMarkdown from "react-markdown";
import { ProgressSpinner } from "primereact/progressspinner";

const Readmd = () => {
  const [documents, setDocuments] = useState({});
  const [loading, setLoading] = useState(true);

  const redirectToGithub = () => {
    window.location.href =
      "https://github.com/StructuralGenomicsConsortium/AIRCHECK-data-package";
  };

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const fetchedDocuments = {};

        const response = await axios.get(`/api/readmefile/data/package/`);

        fetchedDocuments["package"] = response.data;
        setDocuments(fetchedDocuments);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Document retrieval error: " + error);
      }
    };

    fetchDocuments();
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex justify-content-center items-center">
        <ProgressSpinner
          style={{ width: "250px", height: "250px" }}
          strokeWidth="6"
        />
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto px-8 py-16 pt-36 md:pt-16 md:px-16 md:py-24">
        <div className="flex md:flex-row flex-col justify-center align-items-center mt-12">
          <h1 className="m-0 text-3xl font-bold text-blue-900">
            AIRCHECK Dataset Utilities for Python
          </h1>
          <div className="flex justify-center">
            <button
              target="_blank"
              icon="pi pi-code"
              className="w-auto text-xs md:text-sm md:ml-4 md:text-xl flex bg-gradient-to-r from-[#e53201] to-[#f36548] text-white px-3 py-3 md:px-4 md:py-2 rounded-3xl transition ease-in-out delay-250 hover:scale-110"
              href="/datasets"
              onClick={redirectToGithub}
            >
              <p className="font-bold pi pi-code "> View Code</p>
            </button>
          </div>
        </div>

        {Object.entries(documents).map(([docName, content]) => (
          <div id={docName} key={docName} className="mt-12">
            <ReactMarkdown
              className="prose lg:prose-xl max-w-none"
              remarkPlugins={[remarkGfm]}
              components={{
                h1: ({ node, ...props }) => (
                  <h1
                    style={{
                      fontSize: "28px",
                      fontWeight: "bold",
                      marginBottom: "20px",
                      marginTop: "40px",
                    }}
                    {...props}
                  >
                    {props.children}
                  </h1>
                ),
                h2: ({ node, ...props }) => (
                  <h2
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginBottom: "8px",
                      marginTop: "8px",
                    }}
                    {...props}
                  >
                    {props.children}
                  </h2>
                ),
                h3: ({ node, ...props }) => (
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginBottom: "6px",
                      marginTop: "6px",
                    }}
                    {...props}
                  >
                    {props.children}
                  </h3>
                ),
                strong: ({ node, ...props }) => (
                  <strong style={{ fontWeight: "bold" }} {...props} />
                ),
                table: ({ node, ...props }) => (
                  <table
                    style={{ borderCollapse: "collapse", width: "100%" }}
                    {...props}
                  />
                ),
                tr: ({ node, ...props }) => (
                  <tr
                    style={{
                      borderTop: "1px solid #c6cbd1",
                      background: "#fff",
                    }}
                    {...props}
                  />
                ),
                th: ({ node, ...props }) => (
                  <th
                    style={{
                      padding: "6px 13px",
                      border: "1px solid #dfe2e5",
                    }}
                    {...props}
                  />
                ),
                td: ({ node, ...props }) => (
                  <td
                    style={{
                      padding: "6px 13px",
                      border: "1px solid #dfe2e5",
                    }}
                    {...props}
                  />
                ),
                ul: ({ node, ...props }) => (
                  <ul className="list-disc" {...props} />
                ),
                ol: ({ node, ...props }) => (
                  <ol className="list-disc" {...props} />
                ),
                li: ({ node, ...props }) => (
                  <li className="list-disc" {...props} />
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
        ))}
      </div>
    </>
  );
};

export default Readmd;
